import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Global } from '../shared/global';
import { User } from '../models/user';
import { environment } from 'src/environments/environment.local';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    public currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;

    constructor(private http: HttpClient) {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(sessionStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    login(username, password, deviceType, deviceToken) {
        return this.http.post<any>(`${environment.BASE_API_URL}user/validateuser`, { username, password, deviceType, deviceToken })
            .pipe(map(user => {
                // console.log(user);
                //if (Number(user.userid) > 0) {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    // sessionStorage.setItem('currentUser', JSON.stringify(user));
                    // this.currentUserSubject.next(user);
                //}
                return user;
            }));
    }

    SSOLogin(ssoStr:string) {
        return this.http.get<any>(`${environment.BASE_API_URL}user/SSOLogin?ssoStr=${ssoStr}`)
            .pipe(map(user => {
                return user;
            }));
    }

    logout() {       
        // remove user from local storage and set current user to null
        sessionStorage.removeItem('Lot');
        sessionStorage.removeItem('LotId');
        sessionStorage.removeItem('currentUser');        
        sessionStorage.clear();
        this.currentUserSubject.next(null);
    }
}